<template>
  <div>
    <el-form
      :model="productionrecordForm"
      :size="$store.state.formSize"
      :rules="productionrecordFormRules"
      ref="refProductionrecordForm"
      label-width="140px"
    >
      <el-form-item label="产品名称：" prop="productId">
        <el-select
          v-model="productionrecordForm.productId"
          style="width:100%;"
          filterable
          placeholder="请选择产品"
          @change="setbarcode"
        >
          <el-option
            v-for="item in productList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="生产记录号：" prop="recordCode">
        <el-input
          v-model="productionrecordForm.recordCode"
          placeholder="自动生成"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item label="商品分类：">
        <el-input
          v-model="productionrecordForm.categoryName"
          :disabled="true"
          placeholder="选择产品后自动带出"
        ></el-input>
      </el-form-item>
      <el-form-item label="产品类别：">
        <el-input
          v-model="productionrecordForm.productTypeName"
          :disabled="true"
          placeholder="选择产品后自动带出"
        ></el-input>
      </el-form-item>
      <el-form-item label="生产排班：" prop="orderClassesIds">
        <el-select
          v-model="productionrecordForm.orderClassesIds"
          style="width:100%;"
          multiple
          placeholder="请选择生产排班"
          @change="setProductAddress"
        >
          <el-option
            v-for="item in classesList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="生产地址：" prop="address">
        <el-input
          v-model="productionrecordForm.address"
          :disabled="false"
          placeholder="生产地址"
        ></el-input>
      </el-form-item>
      <el-form-item label="生产开始日期：" prop="startDate">
        <el-date-picker
          v-model="productionrecordForm.startDate"
          value-format="yyyy-MM-dd"
          autocomplete="off"
          type="date"
          style="width:100%"
          :placeholder="productionrecordForm.startDate"
          @change="fetchRecordCode"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="生产结束日期：" prop="endDate">
        <el-date-picker
          v-model="productionrecordForm.endDate"
          value-format="yyyy-MM-dd"
          autocomplete="off"
          type="date"
          style="width:100%"
          :placeholder="productionrecordForm.endDate"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="备注：" prop="remark">
        <el-input
          type="textarea"
          v-model="productionrecordForm.remark"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="text-center">
      <el-button
        type="primary"
        :size="$store.state.buttonSize"
        :disabled="isDisabled"
        @click="debounceSubmit"
        >确 定</el-button
      >
      <el-button :size="$store.state.buttonSize" @click="hanleResetFormVals">取 消</el-button>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { debounce } from 'throttle-debounce'
import { getProductionrecordDetail, putProductionrecordAdd, postProductionrecordEdit, getProductionrecordCode } from '@/api/productionrecord'
import { getProductList } from '@/api/product'
import { getSchedulingList } from '@/api/scheduling'

const createForm = () => ({
  // *生产开始日期
  startDate: '',
  // *生产结束日期
  endDate: '',
  // 排班
  orderClassesIds: [],
  // *生产记录号
  recordCode: '',
  remark: '',
  // 商品分类（所选产品带出，只读）
  categoryName: '',
  // 产品类别（所选产品带出，只读）
  productTypeName: '',
  // *产品名称
  productId: null,
  address: ''

})

export default {
  data() {
    return {
      productionrecordForm: createForm(),
      isDisabled: false,
      productList: [],
      classesList: [],
      productionrecordFormRules: {
        startDate: [
          { required: true, message: '请选择生产开始日期', trigger: 'blur' }
        ],
        endDate: [
          { required: true, message: '请选择生产结束日期', trigger: 'blur' }
        ],
        orderClassesIds: [
          { required: true, message: '请选择生产排班', trigger: 'blur' }
        ],
        productId: [
          { required: true, message: '请选择产品', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.debounceSubmit = debounce(300, this.productionrecordSubmit)
  },
  methods: {
    hanleResetFormVals() {
      this.$set(this, 'productionrecordForm', createForm())
      this.$refs.refProductionrecordForm.clearValidate()
      this.$emit('closePopup')
    },
    productionrecordSubmit() {
      this.$refs.refProductionrecordForm.validate(valid => {
        if (!valid) return false
        const productionrecordItems = this.currentID
          ? postProductionrecordEdit
          : putProductionrecordAdd
        const data = {
          startDate: this.productionrecordForm.startDate,
          endDate: this.productionrecordForm.endDate,
          orderClassesIds: this.productionrecordForm.orderClassesIds,
          remark: this.productionrecordForm.remark,
          productId: this.productionrecordForm.productId,
          id: this.currentID || undefined
        }
        // 已生成（选择产品时后端预生成）的记录号随表单提交；为空则由后端保存时自动生成
        if (this.productionrecordForm.recordCode) {
          data.recordCode = this.productionrecordForm.recordCode + ''
        }
        productionrecordItems(data).then(res => {
          if (res.status === 1) {
            this.currentID ? this.$message.success('编辑生产记录成功') : this.$message.success('新增生产记录成功')
            this.$emit('productionrecordFinish')
          } else {
            this.$message.error(res.msg)
            return false
          }
        })
      })
    },
    productionrecordFormPopup(id) {
      const isAdd = !id
      this.$set(this, 'productionrecordForm', createForm())
      if (isAdd) {
        // 此处先不自动生成生产记录号
        // this.productionrecordForm.recordCode = new Date().getTime()
        this.currentID = null
      } else {
        this.isDisabled = true
        getProductionrecordDetail(id).then(res => {
          console.log(res)
          if (res.status === 1) {
            console.log(res)
            this.currentID = id
            this.productionrecordForm.startDate = moment(res.data.startDate).format('YYYY-MM-DD')
            this.productionrecordForm.endDate = moment(res.data.endDate).format('YYYY-MM-DD')
            this.productionrecordForm.recordCode = res.data.recordCode
            this.productionrecordForm.remark = res.data.remark
            this.productionrecordForm.productId = res.data.productId
            this.fillProductInfo(res.data.productId)
            this.productionrecordForm.orderClassesIds = res.data.orderClasses.map(_ => _.id)
            this.productionrecordForm.address = res.data.orderClasses.map(_ => _.address).join('、')
            this.isDisabled = false
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 选择产品后带出商品分类、产品类别并生成生产记录号
    setbarcode(val) {
      this.fillProductInfo(val)
      this.fetchRecordCode()
    },
    // 从所选产品信息中带出商品分类、产品类别并回填（只读展示）
    fillProductInfo(val) {
      const apply = () => {
        const selectObj = this.productList.find(item => item.value === val)
        if (!selectObj) return
        // 产品类别：1:初级农产品、0:加工品
        const productTypeMap = { 1: '初级农产品', 0: '加工品' }
        this.productionrecordForm.categoryName = selectObj.categoryName || ''
        this.productionrecordForm.productTypeName =
          productTypeMap[selectObj.productType] !== undefined
            ? productTypeMap[selectObj.productType]
            : (selectObj.productType || '')
      }
      if (this.productList.length) {
        apply()
      } else {
        this.getGoodsListData().then(apply)
      }
    },
    // 调用后端接口生成生产记录号并回填
    fetchRecordCode() {
      if (!this.productionrecordForm.productId) return
      getProductionrecordCode({
        productId: this.productionrecordForm.productId,
        startDate: this.productionrecordForm.startDate || undefined
      }).then(res => {
        if (res.status === 1) {
          this.productionrecordForm.recordCode = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 获取排班地址并赋值
    setProductAddress(val) {
      this.productionrecordForm.address = this.productionrecordForm.orderClassesIds
        .slice()
        .map(_ => (
          this.classesList
            .find(item => item.value === _).address
        ))
        .join('、')
    },
    // 获取商品列表
    getGoodsListData() {
      return getProductList({
        page: 1,
        size: 1000,
        productState: 1
      }).then(res => {
        if (res.status === 1) {
          this.productList = res.data.rows.map(item => ({
            label: item.productName,
            value: item.id,
            barcode: item.barcode,
            categoryName: item.categoryName,
            productType: item.productType
          }))
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 获取排班列表
    getSchedulingListData() {
      getSchedulingList({
        page: 1,
        size: 1000
      }).then(res => {
        console.log(res)
        if (res.status === 1) {
          const arr = []
          for (let i = 0; i < res.data.rows.length; i++) {
            arr.push({ label: res.data.rows[i].name, value: res.data.rows[i].id, address: res.data.rows[i].address })
          }
          this.classesList = arr
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  },
  mounted() {
    this.getGoodsListData()
    this.getSchedulingListData()
  },
  filters: {
    format(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    },
    formatDate(value) {
      return moment(value).format('YYYY-MM-DD')
    }
  }
}
</script>
